import { styled } from "styled-components";

export const ShareSettingsHeader = styled.h2`
  color: ${({ theme }) => theme.colors.fillPrimary};
  font-size: 1.1rem;
  font-weight: 500;
  display: inline-block;
  margin: 0;
`;
